import { useSplitTreatment } from './useSplitTreatment';
import {
  SPLIT_IO_FEATURE_FLAG_PDP_STRUCTURE,
  SPLIT_IO_FEATURE_FLAG_PDP_STRUCTURE_COOKIE
} from 'constants/split';
import { SPLIT_TRAFFIC_TYPES } from 'au-js-sdk/lib/services/split.io/constants';
import { useProduct } from '../../features/pdp';

const PRODUCTS_IN_TEST = [
  'layflat',
  'hardcover'
];

export const useShowNewPdpStructure = (): boolean => {
  const { product } = useProduct();

  const { treatmentStatus: splitEnabled } = useSplitTreatment(
    SPLIT_IO_FEATURE_FLAG_PDP_STRUCTURE,
    SPLIT_IO_FEATURE_FLAG_PDP_STRUCTURE_COOKIE,
    SPLIT_TRAFFIC_TYPES.ANONYMOUS
  );

  return splitEnabled && PRODUCTS_IN_TEST.includes(product.sku);
};
